import messages from '../../modals/manualPaymentModal/ManualPaymentModal.messages';
import DashboardLink from '../../navigation/DashboardLink';
import { FormattedMessage } from 'react-intl';
import styles from './TruelayerConfirmation.module.css';
import { PhoneNumber } from '../../ui/phoneNumber/PhoneNumber';
import { Button, Icon } from '@iwoca/orion';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { TRUELAYER_REDIRECT_BACK_TO_PAYMENT_CONFIRMATION } from '../EarlyRepayment.actions';

type PaymentFailedProps = {
    accountId: string;
    amount: number;
};

function mapDispatchToProps(dispatch: Dispatch, ownProps: any) {
    return {
        redirectBackToPaymentConfirmation: () =>
            dispatch({
                type: TRUELAYER_REDIRECT_BACK_TO_PAYMENT_CONFIRMATION,
                payload: {
                    accountId: ownProps.accountId,
                    amount: ownProps.amount
                }
            })
    };
}

type PropsFromRedux = ReturnType<typeof mapDispatchToProps>;

const _PaymentFailed = ({
    // These vars are used in redux's ownProps
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    accountId,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    amount,
    redirectBackToPaymentConfirmation
}: PaymentFailedProps & PropsFromRedux) => (
    <>
        <div className={styles.confirmationContainer}>
            <Icon icon="alertCircle" className={styles.alertIcon} />
            <div
                className={styles.primaryContent}
                data-testid="message-container"
            >
                <p>Sorry, we couldn't process your payment.</p>
                <p>Please try again or give us a call</p>
                <PhoneNumber number={'020 3397 3375'} />
            </div>
            <div className="mt-xl flex flex-col p-xl sm:mt-3xl sm:flex-row sm:justify-center">
                <DashboardLink
                    className="mx-0 mb-l h-3xl w-full sm:mr-2xl sm:w-[200px]"
                    variant="secondary"
                >
                    <FormattedMessage {...messages.returnToDashboard} />
                </DashboardLink>
                <Button
                    onClick={redirectBackToPaymentConfirmation}
                    variant="primary"
                    className="h-3xl sm:w-[200px]"
                >
                    Try again
                </Button>
            </div>
        </div>
    </>
);

export const PaymentFailed = connect(
    () => ({}),
    mapDispatchToProps
)(_PaymentFailed);
